import { createSlice } from '@reduxjs/toolkit'

import { changeQuantity } from './actions/change_quantity'

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    status: 'initial',
    error: null,
    isCardError: false
  },
  reducers: {
    resetPaymentStatus: (state) => {
      state.status = 'initial'
      state.error = null
      state.isCardError = false
    },
  },
  extraReducers: (builder) => {
    builder.addCase(changeQuantity.pending, (state) => {
      state.status = 'pending'
      state.error = null
      state.isCardError = false
    })
    builder.addCase(changeQuantity.fulfilled, (state) => {
      state.status = 'completed'
      state.error = null
      state.isCardError = false
    })
    builder.addCase(changeQuantity.rejected, (state, action) => {
      state.status = 'completed'
      state.error = action.payload.errorMessage
      state.isCardError = action.payload.isCardError
    })
  }
})

export const {
  reducer,
  actions: {
    resetPaymentStatus
  }
} = paymentSlice
